var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor",
    d: "M22.98 5.59C22.329 4.432 21.6225 4.219 20.184 4.138C18.747 4.0405 15.1335 4 12.003 4C8.8665 4 5.2515 4.0405 3.816 4.1365C2.3805 4.219 1.6725 4.4305 1.0155 5.59C0.345 6.7465 0 8.7385 0 12.2455C0 12.2485 0 12.25 0 12.25C0 12.253 0 12.2545 0 12.2545V12.2575C0 15.7495 0.345 17.7565 1.0155 18.901C1.6725 20.059 2.379 20.269 3.8145 20.3665C5.2515 20.4505 8.8665 20.5 12.003 20.5C15.1335 20.5 18.747 20.4505 20.1855 20.368C21.624 20.2705 22.3305 20.0605 22.9815 18.9025C23.658 17.758 24 15.751 24 12.259C24 12.259 24 12.2545 24 12.2515C24 12.2515 24 12.2485 24 12.247C24 8.7385 23.658 6.7465 22.98 5.59ZM9 16.75V7.75L16.5 12.25L9 16.75Z"
  })));
}

export default SvgYoutube;